import { styled } from '@mui/material'

export const Wrapper = styled('div')(() => ({
  marginBottom: 2
}))

// Mesma moldura do resumo da recorrência (S.RecurrenceContent), para os dois
// modais lerem como a mesma tela. Antes eram duas caixas aninhadas — a de fora
// aqui e a do resumo — e a moldura dupla encolhia a largura útil.
export const ChargeSession = styled('div')(() => ({
  padding: 16,
  border: '1px solid #E8EBE8',
  borderLeft: '3px solid #01F7C2',
  borderRadius: '8px',
  backgroundColor: '#fff'
}))

export const Separator = styled('div')(() => ({
  width: '1fr',
  flexGrow: '1',
  borderTop: '0.5px dashed #CBCBCB',
  alignSelf: 'center',
  marginTop: '2px'
}))

export const ButtonRecurrenceView = styled('button')(({ theme }) => ({
  all: 'inherit',
  borderRadius: 999,
  cursor: 'pointer',
  outline: '1px solid transparent',
  ['&:focus-within, &:hover']: {
    outlineColor: theme.palette.neutral[200]
  }
}))
